module.exports = __webpack_public_path__ + "static/img/functionpic_zzs.46598cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/android/functionpic_zzs.jpg
// module id = KfNM
// module chunks = 0